import moment from "moment-timezone";
import type { Event } from "../../types/Event";

export const formatEvents = (events: Event[]) => {
    const userTimezone = moment.tz.guess(true);
    return events.map((event) => ({
        ...event,
        id: event.id,
        resourceId:
            typeof event.user === "string"
                ? event.user
                : event?.user?.id || "unassigned-shifts",
        startDate: moment.parseZone(event.startDate).tz(userTimezone, true),
        endDate: moment.parseZone(event.endDate).tz(userTimezone, true),
    }))
}
